<template>
  <browse-filter>
    <browse-filter-checkbox
      label="AppSumo Select"
      value="marketplace"
      :checked="value"
      @click="select"
    >
      <template #label>
        <img
          class="logo"
          :src="SelectLogo"
          alt="AppSumo Select"
        >
      </template>
      <img
        v-popover:filter-select.bottom
        :src="QuestionMark"
        alt="About"
        class="question"
      >
      <client-only>
        <v-popover
          class="popover"
          name="filter-select"
          event="hover"
          :width="300"
        >
          Exclusive offers on the hottest software, expertly tested,
          vetted, and brought to you by the AppSumo team.
        </v-popover>
      </client-only>
    </browse-filter-checkbox>
  </browse-filter>
</template>
<script>
import QuestionMark from '~/static/question-mark.svg';
import SelectLogo from '~/static/appsumo-select.svg';
import BrowseFilter from './BrowseFilter.vue';
import BrowseFilterCheckbox from './BrowseFilterCheckbox.vue';

export default {
  components: {
    BrowseFilter,
    BrowseFilterCheckbox,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      SelectLogo,
      QuestionMark,
    };
  },
  methods: {
    select(event) {
      this.$emit('input', event.target.checked ? false : null);
    },
  },
};
</script>
<style scoped>
em {
  font-style: normal;
  font-size: 12px;
}

.logo {
  height: 14px;
  vertical-align: middle;
}

.question {
  cursor: pointer;
}
</style>
